//  The Vue build version to load with the `import` command
//  (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//  import the vue instance
import Vue from 'vue'
//  import the App component
import App from './App'
//  import the vue router
import VueRouter from 'vue-router'
//  tell vue to use the router
Vue.use(VueRouter)
//  define your routes
const routes = [
  { path: '/', component: Hello },
  { path: '/hyra-ut-bostadsratt', component: Bostadsratt },
  { path: '/kostnadsbaserad-hyra', component: Kostnadsbaserad },
  { path: '/hyra-ut-rum', component: Rum }
]

const router = new VueRouter({
  routes, // short for routes: routes
  mode: 'history'
})

//  import the hello component
import Hello from './components/Hello'
import Bostadsratt from './components/Bostadsratt'
import Kostnadsbaserad from './components/Kostnadsbaserad'
import Rum from './components/Rum'

//  instatinat the vue instance
new Vue({
//  define the selector for the root component
  el: '#app',
  //  pass the template to the root component
  template: '<App/>',
  //  declare components that the root component can access
  components: { App },
  //  pass in the router to the Vue instance
  router
}).$mount('#app') //  mount the router on the app



// WEBPACK FOOTER //
// ./src/main.js